import React from 'react'

import { FontSizes } from 'widgets/Text'

import { ThemeColor, ThemeFontWeight } from 'utils/themes/types'

import { HeadingStyledTitle } from './styled'

interface TitleProps {
  children: React.ReactNode | string
  size?: FontSizes
  fontWeight?: ThemeFontWeight
  bold?: boolean
  black?: boolean
  color?: ThemeColor
  numberOfLines?: number | undefined
}

export const Title: React.FC<TitleProps> = ({
  children,
  size = 'md',
  fontWeight = 'normal',
  bold = false,
  black = false,
  color = 'text',
  numberOfLines = undefined,
}: TitleProps) => {
  return (
    <HeadingStyledTitle
      color={color}
      // eslint-disable-next-line no-nested-ternary
      fontWeight={bold ? 'bold' : black ? 'black' : fontWeight}
      size={size}
      numberOfLines={numberOfLines}
    >
      {children}
    </HeadingStyledTitle>
  )
}
